import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      preferenceSetting: {
        ACTION: ' ',
        NAME: 'Template Name',
        CREATE_AT: 'Date Created',
        MODIFIED_AT: 'Date Modified',
        DEFAULT: 'Default',
        OPEN: 'Open',
        SET_DEFAULT: 'Set as default',
        REMOVE: 'Remove',
        CONFIRMATION: 'Confirmation',
        SET_DEFAULT_CONFIRM_1:
          'Are you sure you want to save this template as default template?',
        SET_DEFAULT_CONFIRM_2: 'Current default template: ',
        CONFIRMATION_2: 'Confirmation',
        DELETE_CONFIRM_1:
          'Are you sure you want to permanently delete this template ',
        DELETE_CONFIRM_2: '?',
        DELETE_CONFIRM_3:
          'Are you sure you want to permanently delete these selected templates?',
        WARNING_DELETE_PANEL:
          'This panel can not be removed. Workspace has to display at least 1 panel.',
        RESET_TEMPLATE: 'Are you sure you want to discard all changes?',
        SAVE_CHANGE: 'Save changes',
        SAVE_CHANGE_NOTE:
          'Do you want to save changes to the current template?',
        CANCEL: 'Cancel',
        SAVE: 'Save',
        SAVE_CHANGE_TO: 'Save your changes to',
        SAVE_AS: 'Save as',
        PLH_INPUT: 'Enter template name',
        CLOSE: 'Close',
        SAVE_SUCCESS: 'Your changes have been successfully saved!',
        SEARCH_TEMPLATE: 'Search template name',
        MORE_TEMPLATE: 'More templates...',
        CORPORATE: 'Corporate',
        BANK: 'Bank',
        NON_BANK: 'Non-bank Financial Institution',
        LIFE_INSURANCE: 'Life Insurance',
        NON_LIFE_INSURANCE: 'Non Life Insurance',
        SERCURITY: 'Securities Firm',
        PREFERENCE_SETTING: 'PREFERENCE SETTING',
        BACK_PAGE: 'Back to Previous Page',
        SAVED_TEMPLATE: 'Saved Templates',
        RESET: 'Reset',
        TEMPLATE_NAME: 'Template Name:',
        PANEL_LIST: 'Panel List',
        PANEL_LIST_NOTE: 'Select to display panel on your current workspace.',
        WORKSPACE_PREVIEW: 'Workspace Preview',
        WORKSPACE_PREVIEW_NOTE:
          'Drag and drop to rearrange display order of each panel.',
        BTN_SAVE: 'Save Template',
        APPLY: 'Apply',
        BACK_SETTING: 'Back to Preference Setting',
        ALL_TEMPLATE: 'ALL TEMPLATES',
        ITEM: 'item',
        ITEMS: 'items',
        SELECTED_1: ' ',
        SELECTED_2: 'selected. ',
        SELECT_ALL: 'Select all ',
        ITEM_2: ' item.',
        ITEMS_2: ' items.',
        UNSELECT: 'Unselect all items.',
        FUND: 'Fund',
        INSURANCE: 'Insurance Company',
        OUT_SCREEN_CONFIRM: 'Changes you made may not be saved.',
        NOTE_BLANK_TEMPLATE:
          'Do you want to save changes to the current template?',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      preferenceSetting: {
        ACTION: ' ',
        NAME: 'Tên Mẫu Cài Đặt',
        CREATE_AT: 'Ngày Tạo',
        MODIFIED_AT: 'Ngày Điều Chỉnh',
        DEFAULT: 'Mặc định',
        OPEN: 'Mở',
        SET_DEFAULT: 'Đặt làm mặc định',
        REMOVE: 'Xóa',
        CONFIRMATION: 'Đặt làm mặc định',
        SET_DEFAULT_CONFIRM_1:
          'Bạn có chắc chắn muốn đặt mẫu này làm mặc định?',
        SET_DEFAULT_CONFIRM_2: 'Mẫu mặc định hiện tại: ',
        CONFIRMATION_2: 'Xác nhận',
        DELETE_CONFIRM_1: 'Bạn có chắc chắn muốn xóa vĩnh viễn mẫu tùy chỉnh ',
        DELETE_CONFIRM_2: ' không?',
        DELETE_CONFIRM_3:
          'Bạn có chắc chắn muốn xóa vĩnh viễn các mẫu tùy chỉnh được chọn không?',
        WARNING_DELETE_PANEL:
          'Vui lòng hiển thị ít nhất một hộp tính năng trên màn hình.',
        RESET_TEMPLATE:
          'Bạn có chắc chắn muốn hủy các thay đổi đã được thực hiện?',
        SAVE_CHANGE: 'Lưu thay đổi',
        SAVE_CHANGE_NOTE:
          'Bạn có muốn lưu lại cài đặt màn hình trước khi thoát?',
        CANCEL: 'Hủy',
        SAVE: 'Lưu',
        SAVE_CHANGE_TO: 'Lưu thay đổi cho',
        SAVE_AS: 'Lưu mới',
        PLH_INPUT: 'Nhập tên mẫu tùy chỉnh',
        CLOSE: 'Đóng',
        SAVE_SUCCESS: 'Các thay đổi của bạn đã được lưu thành công!',
        SEARCH_TEMPLATE: 'Tìm kiếm tên biểu mẫu',
        MORE_TEMPLATE: 'Các biểu mẫu khác...',
        CORPORATE: 'Doanh nghiệp',
        BANK: 'Ngân hàng',
        NON_BANK: 'TCTD phi ngân hàng',
        LIFE_INSURANCE: 'Bảo hiểm nhân thọ',
        NON_LIFE_INSURANCE: 'Bảo hiểm phi nhân thọ',
        SERCURITY: 'Chứng khoán',
        PREFERENCE_SETTING: 'CÀI ĐẶT',
        BACK_PAGE: 'Quay lại trang trước',
        SAVED_TEMPLATE: 'Mẫu cài đặt đã lưu',
        RESET: 'Đặt lại',
        TEMPLATE_NAME: 'Tên Mẫu Cài Đặt:',
        PANEL_LIST: 'Danh Mục',
        PANEL_LIST_NOTE: 'Click chọn để thêm các bảng thông tin vào màn hình.',
        WORKSPACE_PREVIEW: 'Xem Trước Màn Hình',
        WORKSPACE_PREVIEW_NOTE:
          'Kéo và thả để sắp xếp thứ tự hiển thị các bảng thông tin.',
        BTN_SAVE: 'Lưu mẫu',
        APPLY: 'Áp dụng',
        BACK_SETTING: 'Quay lại Cài đặt',
        ALL_TEMPLATE: 'TẤT CẢ MẪU CÀI ĐẶT',
        ITEM: 'bản ghi.',
        ITEMS: 'bản ghi.',
        SELECTED_1: 'Đã chọn ',
        SELECTED_2: ' ',
        SELECT_ALL: 'Chọn tất cả ',
        ITEM_2: ' bản ghi.',
        ITEMS_2: ' bản ghi.',
        UNSELECT: 'Bỏ chọn tất cả.',
        FUND: 'Quỹ',
        INSURANCE: 'Công ty bảo hiểm',
        OUT_SCREEN_CONFIRM:
          'Các thay đổi bạn đã thực hiện có thể không được lưu.',
        NOTE_BLANK_TEMPLATE: 'Bạn có muốn lưu lại cài đặt màn hình?',
      },
    },
  }),
)
